import React, { useState } from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import InputWrapper from '../../../../Components/Form/components/InputWrapper/InputWrapper';
import InputField from '../../../../Components/Form/components/InputField';
import TextAreaField from '../../../../Components/Form/components/TextAreaField';
import { useForm } from 'react-hook-form';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import { FormValues } from '../../../MagicForm/Interfaces/FormValues';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import useApiClient from '../../../Base/Hooks/useApiClient';
import apiClient from '../../../../Services/ApiClient';
import useTranslation from '../../../../Hooks/useTranslation';
// @ts-ignore
import styles from './PatientsGroupsCreateByImport.module.scss';
import useNotification from '../../../../Hooks/useNotification.hook';
import PatientsGroupUpload from '../PatientsGroupsUpload/PatientsGroupUpload';

interface Props {
	onSuccess: () => void;
}

const PatientsGroupsCreateByImport: React.FC<Props> = ({ onSuccess }) => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState(false);

	const validationScheme = yup.object({
		name: yup
			.string()
			.required(t('validation.patientsGroupsCreateByImport.name')),
		description: yup.string().max(255).notRequired(),
	});

	const formMethods = useForm({
		resolver: yupResolver(validationScheme),
		defaultValues: {},
	});
	const { displayError } = useApiClient();
	const { showNotificationSuccess } = useNotification();

	const handleSubmit = async (values: any) => {
		setIsLoading(true);
		try {
			const createdGroup = await apiClient.post(`/group`, {
				name: values.name,
				description: values.description,
			});
			if (createdGroup.status === 200 && values?.file) {
				// @ts-ignore
				const formData = new FormData();
				formData.append('file', values.file);
				const uploadedFiled = await apiClient.postMultipart(
					`/group/${createdGroup.data.id}/member/import`,
					formData,
				);
				if (uploadedFiled.status === 200) {
					showNotificationSuccess({
						content: t('component.groupMsgs.patientsImported'),
					});
					onSuccess();
				}
			}
		} catch (e) {
			displayError(e);
		}
		setIsLoading(false);
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<PatientsGroupUpload />
			<InputWrapper>
				<InputField
					name='name'
					label='base.groupName'
					placeholder='base.enterGroupName'
					isRequired
				/>
			</InputWrapper>
			<InputWrapper>
				<TextAreaField
					name='description'
					label='base.addGroupDescription'
					placeholder='base.writeGroupDescription'
					charactersLimit={255}
					showCharCounter
				/>
			</InputWrapper>
			<SubmitButton onSubmit={handleSubmit} disabled={isLoading} />
		</FormWrapper>
	);
};

export default PatientsGroupsCreateByImport;
